module.exports = __webpack_public_path__ + "static/media/index-bg08-01.b886afe3.jpg";